import { resolveItemDates } from '~/lib/item-dates';

/**
 * FRONT-2235: the shared "Created <date> · Updated <date>" line — a note
 * row, a project attachment, a document/file viewer byline, and the direct
 * `/files/:id` and `/files/doc/:filename` pages all render the exact same
 * pair through this one component, so the precedence rule (`item-dates.ts`)
 * can never drift between surfaces.
 *
 * Deliberately inherits font size and color from its surroundings — it
 * renders a bare inline `<span>`, no size/weight classes of its own — so a
 * compact note row and a byline strip can each style it their own way via
 * `className` rather than fighting a hardcoded look here.
 */
export function ItemDates({
  createdAt,
  updatedAt,
  className = '',
}: {
  createdAt: string | number | Date | null | undefined;
  updatedAt: string | number | Date | null | undefined;
  className?: string;
}) {
  const { created, updated } = resolveItemDates(createdAt, updatedAt);
  if (!created && !updated) return null;

  return (
    <span className={className} data-testid="item-dates">
      {created && <span data-testid="item-created">Created {created}</span>}
      {created && updated && <span className="text-muted-foreground/60"> · </span>}
      {updated && <span data-testid="item-updated">Updated {updated}</span>}
    </span>
  );
}
